import { createStore, createHook } from "react-sweet-state";
import { removeOfficePersonApi } from "../api";
import { toast } from "react-toastify";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    loading: true,
  },
  // actions that trigger store mutation
  actions: {
    deleteData:
      (officeId, personId) =>
      async ({ setState, getState }) => {
        setState({ isLoading: true });

        try {
          const resp = await removeOfficePersonApi({officeId: officeId, personId: personId});

          if (resp.data && resp.data.code === 200) {
            setState({
              isLoading: false,
            });
            return true;
          }
        } catch (err) {
          const errMsg =
            err && err.response ? err.response.data : "Unknown error";
          setState({
            error: errMsg,
            isLoading: false,
          });

          toast.error(errMsg);

          return false;
        }
      },
  },
  // optional, mostly used for easy debugging
  name: "removeSettingOfficeService",
});

export const useRemoveStore = createHook(Store);
